export default (value) => {
    return [
        'asc',
        'desc',
    ].indexOf(value) !== -1;
};
